import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import InsideHeader from './InsideHeader';
import ArticleVisual from './ArticleVisual';
import useInsideSeo from './useInsideSeo';
import { articles, categories } from './articles';

function ArticleCard({ article }) {
  return (
    <article className="inside-card">
      <Link to={`/inside/${article.slug}`} className="inside-card-link" aria-label={`Leggi ${article.title}`}>
        <ArticleVisual article={article} />
        <div className="inside-card-copy">
          <div className="inside-card-topline">
            <span>{article.number} · {article.category}</span>
            <span>{article.readingTime}</span>
          </div>
          <h3>{article.title}</h3>
          <p>{article.subtitle}</p>
          <span className="inside-card-cta">Leggi <b>↗</b></span>
        </div>
      </Link>
    </article>
  );
}

export default function InsideHome() {
  const [activeCategory, setActiveCategory] = useState('Tutti');
  const featured = articles.find((article) => article.featured) || articles[0];
  const filtered = useMemo(
    () => activeCategory === 'Tutti' ? articles : articles.filter((article) => article.category === activeCategory),
    [activeCategory]
  );

  useInsideSeo({
    description: 'JKL / INSIDE racconta mestieri, workflow e cultura della post-produzione televisiva italiana.',
    path: '/inside',
  });

  return (
    <div className="inside-site">
      <InsideHeader />
      <main>
        <section className="inside-hero">
          <div className="inside-hero-copy">
            <p className="inside-kicker">Post-produzione televisiva, dall’interno</p>
            <h1>Le storie iniziano<br />quando le camere<br /><strong>si spengono.</strong></h1>
            <p className="inside-hero-intro">Mestieri, responsabilità, workflow e contraddizioni raccontati da chi lavora davvero nelle sale di montaggio.</p>
            <a className="inside-hero-link" href="#archivio">Esplora la prima serie <span>↓</span></a>
          </div>
          <Link className="inside-feature" to={`/inside/${featured.slug}`}>
            <ArticleVisual article={featured} featured />
            <div className="inside-feature-copy">
              <div className="inside-feature-meta"><span>In evidenza · {featured.number}</span><span>{featured.readingTime}</span></div>
              <h2>{featured.title}</h2>
              <p>{featured.subtitle}</p>
              <span className="inside-feature-link">Leggi l’articolo <b>↗</b></span>
            </div>
          </Link>
        </section>

        <section className="inside-manifesto">
          <p className="inside-section-index">00 / Perché INSIDE</p>
          <div>
            <h2>Non un blog sul video.<br /><strong>Il lavoro televisivo raccontato da dentro.</strong></h2>
            <p>Ruoli che spesso vengono confusi, passaggi che nei crediti non si vedono e decisioni che trasformano il girato in una puntata. INSIDE nasce per raccontare il mestiere, non la sua versione semplificata.</p>
          </div>
        </section>

        <section className="inside-archive" id="archivio">
          <div className="inside-archive-head">
            <div>
              <p className="inside-section-index">01–10 / Prima serie</p>
              <h2>Articoli</h2>
            </div>
            <div className="inside-filters" aria-label="Filtra gli articoli">
              {categories.map((category) => (
                <button key={category} type="button" className={activeCategory === category ? 'active' : ''} onClick={() => setActiveCategory(category)}>
                  {category}
                </button>
              ))}
            </div>
          </div>
          <div className="inside-grid">
            {filtered.map((article) => <ArticleCard key={article.slug} article={article} />)}
          </div>
        </section>


        <section className="inside-story-cta">
          <div className="inside-story-cta-copy">
            <p className="inside-section-index">INSIDE / Redazione aperta</p>
            <h2>Hai una storia che merita di essere raccontata?</h2>
            <p>Un ruolo poco conosciuto, una dinamica di reparto, un workflow assurdo o un’esperienza che racconta davvero come funziona la post-produzione televisiva.</p>
            <span>Puoi inviarla anche chiedendo di restare anonimo.</span>
          </div>
          <Link to="/inside/raccontaci" className="inside-story-cta-link">Raccontaci la tua storia <strong>↗</strong></Link>
        </section>

        <section className="inside-network">
          <div>
            <p className="inside-section-index">JKL — The Private Network</p>
            <h2>INSIDE racconta il settore.<br />JKL mette in contatto chi lo costruisce.</h2>
          </div>
          <a href="/" className="inside-network-link">Scopri il network <span>↗</span></a>
        </section>
      </main>
      <footer className="inside-footer">
        <span>JKL / INSIDE</span>
        <span>Post-produzione televisiva, dall’interno.</span>
        <Link to="/inside/raccontaci">Raccontaci</Link>
      </footer>
    </div>
  );
}
